module.exports = __webpack_public_path__ + "static/vasano_frame1.d736a324.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/animation/vasano_frame1.gif
// module id = ./assets/animation/vasano_frame1.gif
// module chunks = 170844033123148